import React, { useEffect, useState } from 'react'
import Header from './header/Header'
import Stepper, { ASSURANCE_CONCERN, DEPOSIT_CONCERN } from './stepper/Stepper'
import { MakeRequestContext, request } from './MakeRequestContext'
import { ContractRequestModel } from '../../../types/contracts/contractsModel'
import Footer from '../../../components/modalStepper/footer/Footer'
import fetchFactory from '../../../utils/fetchFactory'
import { SignResponseModel } from '../../profile/profileModel'
import links from '../../../enums/linksEnum'
import { useHistory } from 'react-router-dom'
import Loader from '../../../components/loader/Loader'
import { propertyFromApi } from '../../../enums/contractsEnum'

interface AcceptingProps {
	closeDialog: () => void,
}

type MakeRequestProps =
	AcceptingProps

const MakeRequest: React.FC<MakeRequestProps> = (
	{
		closeDialog
	}
) => {
	const history = useHistory()
	const [contracts, setContracts] = useState<ContractRequestModel[]>([])
	const [step, setStep] = useState<number>(0)
	const shouldSelectLease: boolean = contracts.length > 1
	const stepNumber: number = contracts.length > 1 ? 5 : 4
	const [signResponse, setSignResponse] = useState<SignResponseModel | undefined>(undefined)
	const [signStatus, setSignStatus] = React.useState<string | undefined>(undefined)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/contrat/getBaux`).then((response: any) => {
			setContracts(response)
			setIsLoading(false)
		})
	}, [])

	const previousStep = () => {
		let skipPrev = false

		switch (step) {
			case 1:
				request.requestPurpose = ''
				break
			case 2:
				request.requestPurpose = ''
				break
			case 3:
				if (request.requestConcern === ASSURANCE_CONCERN) {
					setStep(step - 2)
					skipPrev = true
				}
				break
			case 4:
				if (request.requestConcern === DEPOSIT_CONCERN) {
					if (shouldSelectLease) {
						setStep(step - 1)
					} else {
						request.requestConcern = ''
						request.requestPurpose = ''
						request.propertyConcerned = ''
						setStep(1)
					}

					skipPrev = true
				} else if (request.requestConcern === ASSURANCE_CONCERN) {
					if (contracts.filter((contract) => contract.eft_Refbail.type_bien === propertyFromApi.apartment).length > 1) {
						setStep(step - 1)
					} else {
						request.requestConcern = ''
						request.requestPurpose = ''
						request.propertyConcerned = ''
						setStep(1)
						skipPrev = true
					}
				} else {
					request.requestConcern = ''
				}

				break
		}

		if (!skipPrev) {
			if (!shouldSelectLease && step === 4) {
				setStep(step - 2)
			}  else {
				setStep(step - 1)
			}
		}
	}

	const nextStep = (signResponse?: SignResponseModel) => {
		if (signResponse) {
			setSignResponse(signResponse)
		}

		if (!shouldSelectLease && step === 2) {
			setStep(step + 2)
		} else {
			setStep(step + 1)
		}
	}

	const resetStep = () => {
		setStep(0)
	}

	//Go to request tab
	const goToRequests = () => {
		history.push(links.requests)
	}

	const onCloseDialog = () => {
		setStep(0)

		request.propertyConcerned = ''
		request.residence = ''
		request.interlocutor = ''
		request.requestType = ''
		request.requestPurpose = ''
		request.requestConcern = ''

		closeDialog()
		if (step >= stepNumber && !(signResponse && !signStatus)) {
			goToRequests()
		}
	}

	return (
		<>
			{
				step < 5 && (
					<Header closeDialog={onCloseDialog} />
				)
			}

			{
				isLoading ? (
					<Loader />
				) : (
					<>
						<MakeRequestContext.Provider
							value={{
								request,
								step,
								setStep,
								previousStep,
								nextStep,
								closeDialog,
								resetStep
							}}
						>
							<Stepper
								contracts={contracts}
								step={step}
								shouldSelectLease={shouldSelectLease}
								stepNumber={stepNumber}
								signResponse={signResponse}
								setSignStatus={setSignStatus}
								signStatus={signStatus}
							/>
						</MakeRequestContext.Provider>

						{
							step >= 1 && step < 5 &&
							<Footer onFooterPreviousClicked={previousStep} onFooterNextClicked={nextStep} step={step} />
						}
					</>
				)
			}
		</>
	)
}

export default MakeRequest
